import { createContext } from '@chakra-ui/react-utils';

import type { DrawerSize } from './types';

export interface DrawerContext {
  level: number;
  operations: { [x: string]: () => void };
  size?: DrawerSize;
}

export const [DrawerContextProvider, useDrawerContext] =
  createContext<DrawerContext>({
    name: 'DrawerContext',
    strict: false,
  });
